// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		payload: value
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function setMenuOpenState( payload ) {
	return {
		type: 'SET_MENU_OPEN_STATE',
		payload
	}
}

export function hasDismissedNewsletterModal() {
	localStorage.setItem( 'hasDismissedNewsletterModal', true )

	return {
		type: 'HAS_DISMISSED_NEWSLETTER_MODAL'
	}
}

export function setConfirmRouteChangeState( value, to ) {
	return {
		type: 'SET_CONFIRM_ROUTE_CHANGE_STATE',
		payload: {
			value, to
		}
	}
}



// WEBPACK FOOTER //
// ./redux/actions/site.jsx